import { createSelector } from "@reduxjs/toolkit";

import { getIsUnderwritingReinstatementAvailable } from "./getIsUnderwritingReinstatementAvailable";
import { selectReinstateablePolicies } from "./selectReinstateablePolicies";

export const getIsReinstatementEligible = createSelector(
  getIsUnderwritingReinstatementAvailable,
  selectReinstateablePolicies,
  (isUnderwritingReinstatementAvailable, { hasLoaded, reinstateablePolicies }) =>
    isUnderwritingReinstatementAvailable && hasLoaded && reinstateablePolicies.length > 0
);
